import * as actioncable from "@rails/actioncable";
// actioncable.logger.enabled = true;
const consumer = actioncable.createConsumer(
  `${import.meta.env.VITE_WS_URL}/cable`
);

const sortedParams = args => {
  return Object.keys(args)
    .toSorted()
    .reduce((acc, curr) => ({ ...acc, [curr]: args[curr].toString() }), {});
};

export function initSocketForChat(pusherId, { newNoteHandler = null }) {
  const [type, id] = pusherId.split("_");
  const subscription = consumer.subscriptions.create(
    sortedParams({
      channel: "ChatChannel",
      type,
      id
    }),
    {
      received: data => {
        if (data.type === "new-note" && newNoteHandler) {
          newNoteHandler(data.data);
        }
      }
    }
  );

  return subscription;
}
export function initSocketForAppointmentContracting(
  id,
  {
    fetchFormsHandler,
    documentHandler = null,
    errorHandler = null,
    finishHandler = null
  }
) {
  const subscription = consumer.subscriptions.create(
    sortedParams({
      channel: "AppointmentContractingChannel",
      id
    }),
    {
      connected() {
        fetchFormsHandler(subscription);
      },
      received: data => {
        if (data.type === "document_id") {
          if (documentHandler) documentHandler(data.data);
        } else if (data.type === "error") {
          if (errorHandler) errorHandler(data.data);
        } else if (data.type === "finish") {
          if (finishHandler) finishHandler(data.data);
        }
      }
    }
  );

  return subscription;
}

export function initSocketForAgencySignup(
  agencyId,
  { niprUpdateHandler = null }
) {
  const subscription = consumer.subscriptions.create(
    sortedParams({
      channel: "AgencySignupChannel",
      id: agencyId
    }),
    {
      received: data => {
        if (data.type === "nipr-update" && niprUpdateHandler) {
          niprUpdateHandler(data.data);
        }
      }
    }
  );

  return subscription;
}
